<template>
  <GenericList api-endpoint="audit" ref="GenericList">
    <template v-slot:title>{{ $t('auditInformation') }}</template>
    <template v-slot:header>
      <AuditHeader />
    </template>
    <template v-slot:item="{ item, index }">
      <AuditItem :item="item" :index="index" @remove-item="removeItem" />
    </template>
  </GenericList>
</template>

<script>
import AuditHeader from './AuditHeader.vue';
import AuditItem from './AuditItem.vue';
import GenericList from '../generic/GenericSearchList.vue';

export default {
  components: {
    AuditHeader,
    AuditItem,
    GenericList,
  },
  methods: {
    removeItem(item) {
      if (this.$refs.GenericList) {
        this.$refs.GenericList.removeItem(item);
      }
    },
  },
};
</script>
